const auth = {
  browser_opened_plugin:
    "You'll be redirected to the browser to finish the process.",
  browser_opened_web: "You'll be redirected to finish the process.",
} as const;

export default auth;
